(function () {
  let swiperLoadAttempts = 0;
  let resizeTimer;

  function getSlideCount(carousel) {
    const count = parseInt(carousel.dataset.slideCount || '0', 10);
    if (!Number.isNaN(count) && count > 0) return count;
    return carousel.querySelectorAll('.swiper-slide').length;
  }

  function equalizeSlideHeights(carousel) {
    const slides = carousel.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    slides.forEach((slide) => {
      slide.style.height = '';
    });

    let maxHeight = 0;
    slides.forEach((slide) => {
      maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });

    if (!maxHeight) return;

    slides.forEach((slide) => {
      slide.style.height = `${maxHeight}px`;
    });
  }

  function scheduleEqualizeSlideHeights(carousel) {
    equalizeSlideHeights(carousel);
    window.requestAnimationFrame(() => {
      equalizeSlideHeights(carousel);
    });
  }

  function bindSlideHeightSync(carousel) {
    carousel.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', () => scheduleEqualizeSlideHeights(carousel), { once: true });
    });
  }

  function initPromotedCollectionCarousels() {
    if (typeof Swiper === 'undefined') {
      if (swiperLoadAttempts < 40) {
        swiperLoadAttempts += 1;
        window.setTimeout(initPromotedCollectionCarousels, 50);
      }
      return;
    }

    document.querySelectorAll('[data-promoted-collection-carousel]').forEach((carousel) => {
      const paginationEl = carousel.querySelector('.promoted-collection__pagination');
      const slideCount = getSlideCount(carousel);
      const hasMultipleSlides = slideCount > 1;
      const autoplayEnabled = carousel.dataset.autoplay === 'true';
      const loopEnabled = carousel.dataset.loop === 'true';
      const autoplaySpeedSeconds = parseInt(carousel.dataset.autoplaySpeed || '5', 10);
      const autoplayDelay =
        (Number.isNaN(autoplaySpeedSeconds) ? 5 : Math.min(12, Math.max(5, autoplaySpeedSeconds))) * 1000;

      if (carousel.swiper) {
        carousel.swiper.destroy(true, true);
      }

      const swiper = new Swiper(carousel, {
        slidesPerView: 1.65,
        spaceBetween: 12,
        watchOverflow: true,
        loop: loopEnabled && hasMultipleSlides,
        pagination: hasMultipleSlides
          ? {
              el: paginationEl,
              clickable: true,
            }
          : false,
        autoplay:
          autoplayEnabled && hasMultipleSlides
            ? {
                delay: autoplayDelay,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }
            : false,
        breakpoints: {
          750: {
            slidesPerView: 2.35,
            spaceBetween: 16,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
        },
        on: {
          init() {
            scheduleEqualizeSlideHeights(carousel);
          },
          resize() {
            scheduleEqualizeSlideHeights(carousel);
          },
        },
      });

      bindSlideHeightSync(carousel);
      scheduleEqualizeSlideHeights(carousel);

      if (!carousel.dataset.heightsBound) {
        carousel.dataset.heightsBound = 'true';
        swiper.on('breakpoint', () => scheduleEqualizeSlideHeights(carousel));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromotedCollectionCarousels);
  } else {
    initPromotedCollectionCarousels();
  }

  document.addEventListener('shopify:section:load', initPromotedCollectionCarousels);

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      document.querySelectorAll('[data-promoted-collection-carousel]').forEach((carousel) => {
        scheduleEqualizeSlideHeights(carousel);
      });
    }, 150);
  });
})();
